import React from "react";
import { Button, IconButton, useMediaQuery, useTheme } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { keyframes } from "@emotion/react";
import { useLocation } from "react-router-dom";

const pulseRing = keyframes`
  0%   { box-shadow: 0 0 0 0 rgba(22, 110, 233, 0.45); }
  70%  { box-shadow: 0 0 0 12px rgba(22, 110, 233, 0); }
  100% { box-shadow: 0 0 0 0 rgba(22, 110, 233, 0); }
`;

export default function FloatingBookButton() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();

  const handleClick = () => {
    window.open(
      "https://calendly.com/tekkdev-support/new-meeting",
      "_blank",
      "noopener,noreferrer"
    );
  };

  // Hide on AI chatbot page — adjust the path to match your route
  const hiddenPaths = ["/chat", "/ai-chatbot", "/chatbot"];
  if (hiddenPaths.some((path) => location.pathname.startsWith(path))) {
    return null;
  }

  const sharedSx = {
    position: "fixed",
    bottom: { xs: 20, md: 32 },
    right: { xs: 16, md: 28 },
    zIndex: 9999,
    backgroundColor: "#166EE9",
    color: "#fff",
    boxShadow: "0 6px 24px rgba(22, 110, 233, 0.45)",
    animation: `${pulseRing} 2.4s ease-out infinite`,
    transition: "all 0.25s ease",
    "&:hover": {
      backgroundColor: "#145ec7",
      transform: "translateY(-3px) scale(1.05)",
      boxShadow: "0 12px 32px rgba(22, 110, 233, 0.6)",
      animationPlayState: "paused",
    },
    "&:active": {
      transform: "translateY(-1px) scale(0.98)",
    },
  };

  if (isMobile) {
    return (
      <IconButton
        onClick={handleClick}
        aria-label="Book a Meeting"
        sx={{
          ...sharedSx,
          width: 52,
          height: 52,
          borderRadius: "50%",
          "& svg": { fontSize: "1.4rem" },
        }}
      >
        <CalendarMonthIcon />
      </IconButton>
    );
  }

  return (
    <Button
      variant="contained"
      startIcon={<CalendarMonthIcon sx={{ fontSize: "1.2rem" }} />}
      onClick={handleClick}
      sx={{
        ...sharedSx,
        borderRadius: "50px",
        height: "52px",
        px: 3.5,
        fontWeight: 700,
        fontSize: "0.92rem",
        fontFamily: "Roboto, sans-serif",
        textTransform: "none",
        letterSpacing: "0.02em",
        whiteSpace: "nowrap",
      }}
    >
      Book a Meeting
    </Button>
  );
}